module.exports = __webpack_public_path__ + "img/602x698 Food.5ebb0de7.jpg";